import cn from "classnames";
import { IconCheckCircleAlt, IconX } from "./icons";
import { StatusText } from "./status-text";

export const EnabledStatus = ({
  enabled,
  className,
}: {
  enabled: boolean;
  className?: string;
}) => (
  <StatusText
    className={cn(enabled ? "text-forest" : "text-red", className)}
    icon={
      enabled ? (
        <IconCheckCircleAlt variant="sm" color="currentColor" />
      ) : (
        <IconX variant="sm" color="currentColor" />
      )
    }
  >
    {enabled ? "Enabled" : "Disabled"}
  </StatusText>
);
